export const AI_PREFERENCE_CHANGED_EVENT = "sami:ai-preference-changed";
